/**
 * @description: 一级菜单
 * @author: fire
 * @update: hwx
 */
<template>
	<ul>
		<router-link
			tag="li"
			v-for="menuItem in menunew"
			:key="menuItem.id"
			:to="{ path: menuItemPath(menuItem) }"
			class="menu-item"
			:class="{'active':menuItem.id===selectedMenu.id}"
		>
			<template v-if="content == 'text'">
				<span @click="handleClick(menuItem)">{{menuItem.name}}</span>
			</template>
			<template v-if="content == 'block'">
				<div class="sign" :class="menuClassIcon(menuItem.icon)" @click="handleClick(menuItem)"></div>
				<div class="title" @click="handleClick(menuItem)">{{menuItem.name}}</div>
			</template>
		</router-link>
	</ul>
</template>

<script>
	import * as types from '@/store/types'
	export default {
		name: '',
		props: {
			'content': {
				type: String,
				default: function() {
					return 'text';
				}
			}
		},
		data() {
			return {}
		},
		computed: {
			menunew() {
				let menu = []
				// 首次登陆等待获取 menunew
				if(this.$store.state.menunew.length > 0) {
					menu = JSON.parse(this.$store.state.menunew)
				}
				return menu
			},
			selectedMenu() {
				return this.$store.state.selectedMenu
			},
		},
		created: function() {
			this.$on('firstMenu', (menuItem) => {
				this.firstMenu(menuItem);
			});
		},
		methods: {
			// icon类名
			menuClassIcon(icon) {
				return icon + "120x100"
			},
			// 跳转地址
			menuItemPath(menuItem) {
				// 三级菜单逐步开放
				if(menuItem.id == '544') {
					return `/${menuItem.url}/${menuItem.submenu[0].url}/${menuItem.submenu[0].submenu[0].url}`;
				} else {
					return `/${menuItem.url}/${menuItem.submenu[0].url}`;
				}
			},
			// 点击一级菜单
			firstMenu(menuItem) {
				this.$store.commit(types.SELECTEDMENU, menuItem)
				this.$root.$emit("firstMenuClick", menuItem);
			},
			// 新增处理点击的方法
			handleClick(menuItem) {
				// 先触发路由变化
				this.$router.push(this.menuItemPath(menuItem));
				// 然后执行firstMenu
				this.$nextTick(() => {
					this.firstMenu(menuItem);
				});
			}
		}
	}
</script>
<style lang="less">
	.menu-item {
		span {
			display: inline-block;
			width: 100%;
			height: 100%;
		}
	}
	.icon-sale-manage120x100 {
		background: url('../assets/images/icon-sale-manage120x100.png') center center no-repeat;
	}
	.icon-commodity-manage120x100 {
		background: url('../assets/images/icon-commodity-manage120x100.png') center center no-repeat;
	}
	.icon-warehouse-manage120x100 {
		background: url('../assets/images/icon-warehouse-manage120x100.png') center center no-repeat;
	}
	.icon-finance-report120x100 {
		background: url('../assets/images/icon-finance-report120x100.png') center center no-repeat;
	}
	.icon-staff-manage120x100 {
		background: url('../assets/images/icon-staff-manage120x100.png') center center no-repeat;
	}
	.icon-system-set120x100 {
		background: url('../assets/images/icon-system-set120x100.png') center center no-repeat;
	}
	.icon-bill-manage120x100 {
		background: url('../assets/images/icon-bill-manage120x100.png') center center no-repeat;
	}
	.icon-ticket-system120x100 {
		background: url('../assets/images/icon-ticket-system120x100.png') center center no-repeat;
	}
	.icon-self-service-set120x100 {
		background: url('../assets/images/icon-self-service-set120x100.png') center center no-repeat;
	}
</style>